import {
  createCurrencyQuery,
  createLocationQuery,
  createParkingQuery,
  createFlightQuery,
} from "@mozioinc/query";
import posthog from "posthog-js";
import { getCurrencyFromSearchParams } from "./currency";
import { getEnvs } from "./env";
import { getInitialLocale } from "./translation";
import { getWhiteLabel } from "./white-label";

const { QUERY_ENV } = getEnvs();

export const currencyQuery = createCurrencyQuery(() => ({
  ctx: {
    env: QUERY_ENV,
  },
  headers: {
    "api-key": "c09cc3d01bbe22cb5d7afab4f82c8f3f",
    lang: getInitialLocale(),
  },
}));

export const locationQuery = createLocationQuery({
  ctx: {
    env: QUERY_ENV,
  },
  headers: {
    "api-key": "c09cc3d01bbe22cb5d7afab4f82c8f3f",
    lang: getInitialLocale(),
  },
});

export const flightQuery = createFlightQuery({
  ctx: {
    env: QUERY_ENV,
  },
  headers: {
    "api-key": "c09cc3d01bbe22cb5d7afab4f82c8f3f",
    lang: getInitialLocale(),
  },
});

export const parkingQuery = createParkingQuery(() => ({
  ctx: {
    env: QUERY_ENV,
    currency: getCurrencyFromSearchParams(),
  },
  headers: {
    // NOTE: This is a temporary solution. We'll include user token once the we implement user login feature.
    Authorization:
      QUERY_ENV === "production"
        ? "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoibW96aW9fcHJvZCJ9.pHDPxF5Js56xKwBN2adPng4-pA2z6i2Ff9_hPF0uwGs" // cspell:disable-line
        : "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoibW96aW9fc3RhZ2luZyJ9.21e7_dGIyNXfg9yqMwyopKBnYrMSdIx4QnD1ueVxDYw", // cspell:disable-line
    lang: getInitialLocale(),
    "white-label-id": getWhiteLabel().id,
    "white-label-name": getWhiteLabel().name,
    "partner-ref": getWhiteLabel().partnerRef,
    hostname: location.hostname,
    "distinct-id": posthog.get_distinct_id(),
  },
}));
